import styled from "styled-components";

/**
 * Header do componente HeaderContainer.
 */
export const HeaderContainer = styled.div`
  padding: ${({ theme }) => theme.spacing(0.15)}
    ${({ theme }) => theme.spacing(2.5)} 0;
  border-radius: ${({ theme }) => theme.spacing(1.75)}
    ${({ theme }) => theme.spacing(1.75)} 0 0;
  border: 1px solid ${({ theme }) => theme.colors.darkGray};
  background-color: ${({ theme }) => theme.colors.darkGray};
  justify-content: space-between;
  align-items: center;
  display: flex;

  button {
    border-radius: ${({ theme }) => theme.borderRadius.small};
    margin-right: ${({ theme }) => theme.spacing(-1.5)};
    color: ${({ theme }) => theme.colors.white};
    padding: ${({ theme }) => theme.spacing(1)};
    background: transparent;
    transition: all 0.3s;
    cursor: pointer;
    border: none;

    &:hover {
      background: ${({ theme }) => theme.colors.darkGray};
    }
  }
`;
